import { Select } from 'antd'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

import React, { useState } from 'react'


const CustomSelectMenu = ({ name = 'name', options, onChange, placeholder }) => {

    const [open, setOpen] = useState(false)
    return (
        <Select
            onClick={() => setOpen(!open)}
            open={open}
            onBlur={() => setOpen(false)}
            className={`custom_select_menu ${open && "open"}`}
            placeholder={placeholder}
            style={{ width: 320 }}
            onChange={(v) => onChange({ target: { value: v, name } })}
            options={options}
            suffixIcon={<CaretDownOutlined style={{ color: '#1a99ca', fontSize: 20, }} />}

        />
    )
}

export default CustomSelectMenu